import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, withCtx as _withCtx } from "vue"




import { ElSelect } from "element-plus";
import { ElOption } from "element-plus";


export default /*@__PURE__*/_defineComponent({
  __name: 'vi-select',
  props: {
    optionKeyKey: { default: "key" },
    optionLabelKey: { default: "label" },
    optionValueKey: { default: "value" },
    selectedOption: {},
    options: {}
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;
const handleSelect = (value: any) => {
  emit("change", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElSelect), {
    filterable: "",
    "default-first-option": "",
    "model-value": __props.selectedOption,
    onChange: handleSelect
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
        return (_openBlock(), _createBlock(_unref(ElOption), {
          key: option[__props.optionKeyKey],
          value: option[__props.optionValueKey],
          label: option[__props.optionLabelKey]
        }, null, 8, ["value", "label"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})